export default {
  "states": {
    "created": "Not requested",
    "pending": "Pending",
    "edited": "Edited",
    "accepted": "Accepted",
    "rejected": "Denied"
  },
  "months": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "dicember": "December"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/flows/index.js